import ko from "knockout";
import register from "flow/knockout/register";

register.registerKnockoutBinding("stopBinding", {
    init: function () {
        return { controlsDescendantBindings: true };
    }
});

ko.virtualElements.allowedBindings.stopBinding = true;
